<script lang="ts">
  import type { LocalInputFile, FileKind } from '../../core/files/file.types';
  import Card from '../../components/Card.svelte';

  export let files: LocalInputFile[];

  function kindLabel(kind: FileKind): string {
    switch (kind) {
      case 'afd': return 'AFD';
      case 'aej': return 'AEJ';
      case 'complementary': return 'Complementar';
      default: return 'Desconhecido';
    }
  }

  function kindIcon(kind: FileKind): string {
    switch (kind) {
      case 'afd': return '🕐';
      case 'aej': return '📋';
      case 'complementary': return '📎';
      default: return '📄';
    }
  }

  function formatSizeKb(bytes: number): string {
    return (bytes / 1024).toFixed(1);
  }
</script>

<div class="file-summary" aria-label="Arquivos carregados">
  <h2 class="file-summary__heading">Arquivos carregados</h2>
  <ul class="file-summary__list" role="list">
    {#each files as file (file.id)}
      <li class="file-summary__item">
        <Card padding="sm">
          <div class="file-card">
            <span class="file-card__icon" aria-hidden="true">{kindIcon(file.kind)}</span>
            <div class="file-card__info">
              <span class="file-card__name">{file.name}</span>
              <div class="file-card__meta">
                <span class="file-card__badge file-card__badge--{file.kind}">{kindLabel(file.kind)}</span>
                <span class="file-card__size">{formatSizeKb(file.sizeBytes)} KB</span>
                <span class="file-card__encoding">{file.encoding}</span>
              </div>
            </div>
          </div>
        </Card>
      </li>
    {/each}
  </ul>
</div>

<style>
  .file-summary__heading {
    font-size: 1rem;
    font-weight: 600;
    color: var(--ptt-gray-300);
    margin: 0 0 var(--ptt-space-3);
  }

  .file-summary__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--ptt-space-2);
  }

  .file-card {
    display: flex;
    align-items: center;
    gap: var(--ptt-space-3);
  }

  .file-card__icon {
    font-size: 1.5rem;
    flex-shrink: 0;
  }

  .file-card__info {
    display: flex;
    flex-direction: column;
    gap: var(--ptt-space-1);
    min-width: 0;
  }

  .file-card__name {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--ptt-gray-300);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .file-card__meta {
    display: flex;
    align-items: center;
    gap: var(--ptt-space-2);
    flex-wrap: wrap;
  }

  .file-card__badge {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 2px var(--ptt-space-2);
    border-radius: var(--ptt-radius-sm);
  }

  .file-card__badge--afd {
    background: color-mix(in srgb, var(--ptt-purple-100) 12%, var(--ptt-white));
    color: var(--ptt-purple-100);
  }

  .file-card__badge--aej {
    background: color-mix(in srgb, var(--ptt-blue-100) 12%, var(--ptt-white));
    color: var(--ptt-blue-100);
  }

  .file-card__badge--complementary {
    background: color-mix(in srgb, var(--ptt-yellow-200) 12%, var(--ptt-white));
    color: var(--ptt-gray-300);
  }

  .file-card__badge--unknown {
    background: color-mix(in srgb, var(--ptt-gray-60) 12%, var(--ptt-white));
    color: var(--ptt-gray-200);
  }

  .file-card__size,
  .file-card__encoding {
    font-size: 0.75rem;
    color: var(--ptt-gray-100);
  }
</style>
